export default __webpack_public_path__ + "static/media/grafik01.3a13b87a.svg";